import store from "../store";
function userHasPermission(permission: string) {
	const $store = store as any;
	const userPermissions = $store.state.user.permissions;
	return userPermissions.includes(permission);
}
export const PermissionUtil = {
	userHasPermission
};
